export default __webpack_public_path__ + "static/media/zoom-out-enabled.bced9205.svg";